var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3684 0.930769H13.8947V0H12.7368V0.930769H9.26316V0H8.10526V0.930769H4.63158V0H3.47368V0.930769H2.3128C1.03548 0.930769 0 1.75893 0 2.79565V22.3351C0 23.3651 1.0316 24.2 2.3128 24.2H19.6872C20.9645 24.2 22 23.3718 22 22.3351V2.79565C22 1.76571 20.9684 0.930769 19.6872 0.930769H18.5263V0H17.3684V0.930769ZM17.3684 1.86154H13.8947V2.79231H12.7368V1.86154H9.26316V2.79231H8.10526V1.86154H4.63158V2.79231H3.47368V1.86154H2.31574C1.67628 1.86154 1.15789 2.27007 1.15789 2.79517V22.3356C1.15789 22.8512 1.6844 23.2692 2.31574 23.2692H19.6843C20.3237 23.2692 20.8421 22.8607 20.8421 22.3356V2.79517C20.8421 2.27954 20.3156 1.86154 19.6843 1.86154H18.5263V2.79231H17.3684V1.86154ZM3.47368 5.58462V6.51538H18.5263V5.58462H3.47368ZM3.47368 8.37692V9.30769H18.5263V8.37692H3.47368ZM3.47368 11.1692V12.1H18.5263V11.1692H3.47368ZM3.47368 13.9615V14.8923H18.5263V13.9615H3.47368ZM3.47368 16.7538V17.6846H18.5263V16.7538H3.47368ZM3.47368 19.5462V20.4769H18.5263V19.5462H3.47368Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientProfileIcon);
export default __webpack_public_path__ + "static/media/PatientProfileIcon.8e78198660a6152fc8d05dfdab8ad33e.svg";
export { ForwardRef as ReactComponent };